import PropTypes from 'prop-types';
import styles from './styles.module.css';

const GroupDisplay = (props) => {
  const {
    slides,
  } = props;

  return (
    <div className={styles.group}>
      {slides}
    </div>
  );
};

GroupDisplay.propTypes = {
  slides: PropTypes.array,
};

export default GroupDisplay;
